/* jokers-size-card.js — 101026 (b: arm-once scheduling + 2s safety re-check; c: compact two-line card; d: "Fit Guarantee voided" wording; e: costume's own size names)
   Size Fit status in the CART DRAWER + two product-page nudges. Loaded once from
   snippets/jokers-scan-reminder.liquid (rendered in the cart drawer on every page).

   CART DRAWER — one small card under each ADULT costume line (product type contains
   "men", same test as the checkout popup):
     _jk_size_scan = recommended          → green  "Size Fit Guarantee activated"
     _jk_size_scan = ignored  (+ rec known) → amber "Not covered — recommended size is X" + Swap to X
     _jk_size_scan = nomatch / mismatch   → grey   "Size Fit Guarantee not available for this costume"
     no stamp, device HAS a scan          → judged from the product page's cached result
                                            (jk_ms:<product id>): match → green, differs → amber + Swap,
                                            unknown → nothing (the checkout size check handles it)
     no stamp, no scan, cart not yet answered → "Is Medium the right size?"
                                            [Check my size] [I know my size]
     no stamp, no scan, already answered  → grey "Size Fit Guarantee not activated · Check my size"
   "I know my size" writes the SAME cart attributes as the checkout popup's one-tap skip
   (Size Scan: Ignored + reason + device + time), so the checkout popup never asks again and
   the Flow tag "Size Ignored" still lands. It writes CART ATTRIBUTES only — never line
   properties — so line keys don't change and ShipZip's per-line delivery writes are untouched.
   "Check my size": on a costume product page (Mirrorsize button present) the drawer closes and
   the scan opens right there; anywhere else → /pages/find-your-fit (Women's/Men's preset),
   whose "Back to my cart" opens the drawer again.
   "Swap to X": same add-then-remove as the checkout popup's swap (copies the line's delivery
   properties, stamps the new line recommended), holding window.JokersCart so jokers-cart.js
   stands down while it runs.

   PRODUCT PAGE (only when sizer-block's amber "You've selected M — your recommended size is XL"
   card is showing):
     - its "Switch to XL" link is styled as a proper green button
     - a one-line reminder appears directly under Add to cart:
       "Medium isn't covered by the Size Fit Guarantee · Switch to X-Large"
   Nothing blocks anything; nothing here stops an add or a checkout. */
(function () {
  if (window.__jkSizeCard) return;
  window.__jkSizeCard = true;

  /* ---------------- shared helpers ---------------- */
  var SKIP_REASON = 'Already knows their size';
  function hasScan() { try { return !!localStorage.getItem('ms_access_code2'); } catch (e) { return false; } }
  function cachedScan(pid) {
    try { var c = localStorage.getItem('jk_ms:' + pid); return c ? JSON.parse(c) : null; } catch (e) { return null; }
  }
  function isCostume(it) { return String(it.product_type || '').toLowerCase().indexOf('men') !== -1; }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function szNorm(v) {
    v = String(v || '').toLowerCase().replace(/size/g, '').replace(/[^a-z0-9]/g, '');
    var m = { extrasmall: 'xs', xsmall: 'xs', small: 's', medium: 'm', large: 'l',
              extralarge: 'xl', xlarge: 'xl', xxlarge: 'xxl', '2xl': 'xxl', '2xlarge': 'xxl',
              xxxlarge: 'xxxl', '3xl': 'xxxl', '3xlarge': 'xxxl', '4xl': 'xxxxl', xxxxlarge: 'xxxxl' };
    return m[v] || v;
  }
  function szKey(v) {
    v = String(v || '');
    var head = v.split(/\s+-\s+|\s*\(/)[0];
    var word = head.match(/^\s*(extra\s*small|extra\s*large|x*s|x*l|\dxl|small|medium|large|m)\b/i);
    if (word) return szNorm(word[1]);
    return szNorm(head);
  }
  function shortSize(v) { return String(v || '').split(/\s+-\s+|\s*\(/)[0].trim(); }
  function prettySize(v) {
    var n = { xs: 'Extra Small', s: 'Small', m: 'Medium', l: 'Large', xl: 'Extra Large', xxl: 'XXL', xxxl: 'XXXL' }[szKey(v)];
    return n || String(v || '');
  }
  function lineSize(it) {
    var o = (it.options_with_values || []).filter(function (x) { return /size/i.test(x.name || ''); })[0];
    if (o) return o.value;
    return (it.variant_options && it.variant_options[0]) || it.variant_title || '';
  }
  function isOneSize(sz) { return !sz || /^(one\s*size|os|standard|free\s*size|default title)/i.test(String(sz).trim()); }
  function stampNow() {
    try {
      return new Date().toLocaleString('en-AU', { timeZone: 'Australia/Brisbane', day: '2-digit', month: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit' }) + ' (Brisbane)';
    } catch (e) { return new Date().toString(); }
  }
  function deviceInfo() {
    var ua = navigator.userAgent || '';
    var dev = /iPhone/.test(ua) ? 'iPhone'
            : /iPad/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) ? 'iPad'
            : /Android/.test(ua) ? (/Mobile/.test(ua) ? 'Android phone' : 'Android tablet')
            : /Windows/.test(ua) ? 'Windows computer'
            : /Macintosh/.test(ua) ? 'Mac'
            : /CrOS/.test(ua) ? 'Chromebook'
            : /Linux/.test(ua) ? 'Linux computer'
            : 'Other device';
    var br = /SamsungBrowser/.test(ua) ? 'Samsung Internet'
           : /EdgA?\//.test(ua) ? 'Edge'
           : /FBAN|FBAV|Instagram/.test(ua) ? 'Facebook/Instagram in-app'
           : /CriOS|Chrome\//.test(ua) ? 'Chrome'
           : /FxiOS|Firefox\//.test(ua) ? 'Firefox'
           : /Safari\//.test(ua) ? 'Safari'
           : 'Other browser';
    return dev + ' · ' + br;
  }

  /* cart writes wait for jokers-cart.js to be idle, and hold .removing so it stands down */
  function jk() { return (window.JokersCart = window.JokersCart || { writes: 0, removing: false }); }
  function whenIdle() {
    return new Promise(function (res) {
      (function w(n) { var J = jk(); if ((!J.writes && !J.removing) || n > 160) { res(); return; } setTimeout(function () { w(n + 1); }, 50); })(0);
    });
  }
  function lock(fn) {
    return whenIdle().then(function () {
      jk().removing = true;
      var done = function () { jk().removing = false; };
      return Promise.resolve().then(fn).then(function (v) { done(); return v; }, function (e) { done(); throw e; });
    });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ---------------- styles ---------------- */
  var css = [
    '.jk-sc{margin:6px 0 0;padding:6px 10px;border-radius:8px;font-size:12.5px;line-height:1.35;text-align:left;border:1px solid transparent;}',
    '.jk-sc p{margin:0 !important;padding:0 !important;}',
    '.jk-sc b{font-weight:800;}',
    '.jk-sc__acts{margin-top:3px !important;display:flex;flex-wrap:wrap;align-items:center;gap:2px 10px;}',
    '.jk-sc button{all:unset;cursor:pointer;font:inherit;font-weight:700;color:inherit;text-decoration:underline;text-underline-offset:2px;}',
    '.jk-sc button.jk-sc__go{color:#1f8a4c;font-weight:800;}',
    '.jk-sc button[disabled]{opacity:.55;cursor:default;}',
    '.jk-sc--ask{background:#f3f6f9;border-color:#d3dae1;color:#22384d;}',
    '.jk-sc--ok{background:#e9f7ee;border-color:#b9e2c8;color:#145c33;}',
    '.jk-sc--off{background:#fff8e6;border-color:#f2d791;color:#6b4a00;}',
    '.jk-sc--off button.jk-sc__go{color:#145c33;}',
    '.jk-sc--na{background:#f3f6f9;border-color:#e3e8ed;color:#55606b;}',
    '.jk-sc__err{margin-top:3px !important;font-weight:700;color:#c0392b;}',
    /* product page: the amber card's "Switch to XL" as a real button */
    '.jk-sz--recommended.jk-sz--off .jk-sz__card-links a[data-jk-switch],',
    '.rte .jk-sz--recommended.jk-sz--off .jk-sz__card-links a[data-jk-switch]{display:inline-flex !important;align-items:center;justify-content:center;padding:8px 14px !important;border-radius:8px !important;background:#1f8a4c !important;background-image:none !important;color:#fff !important;font-size:13px !important;font-weight:800 !important;text-decoration:none !important;white-space:nowrap;}',
    '.jk-sz--recommended.jk-sz--off .jk-sz__card-links a[data-jk-switch]:hover{background:#17752f !important;}',
    /* product page: reminder under Add to cart */
    '.jk-atc-note{margin:10px 0 0 !important;padding:9px 12px;border-radius:8px;background:#fff8e6;border:1px solid #f2d791;color:#6b4a00;font-size:13.5px;line-height:1.4;}',
    '.jk-atc-note[hidden]{display:none !important;}',
    '.jk-atc-note button{background:none;border:0;padding:0;margin-left:4px;font:inherit;font-weight:800;color:#6b4a00;text-decoration:underline;cursor:pointer;}'
  ].join('\n');
  var st = document.createElement('style');
  st.id = 'jk-size-card-css';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  /* =====================================================================
     CART DRAWER
     ===================================================================== */
  var drawer = null;
  var cart = null;             // last /cart.js
  var sig = '';                // drawer line ids last time we fetched
  var fetching = false, refetch = false;
  var timer = null;
  var busyLines = {};          // line key → action running (swap / skip)
  var errors = {};             // line key → message

  function drawerLines() {
    return drawer ? Array.prototype.slice.call(drawer.querySelectorAll('li[id^="CartDrawer-Item-"]')) : [];
  }
  function itemFor(li, items, i) {
    var key = li.id.replace('CartDrawer-Item-', '');
    var it = items.filter(function (x) { return x.key === key; })[0];
    if (it) return it;
    var vid = li.getAttribute('data-variant-id');
    var same = items.filter(function (x) { return String(x.variant_id || x.id) === String(vid); });
    if (same.length === 1) return same[0];
    return items[i] && String(items[i].variant_id || items[i].id) === String(vid) ? items[i] : null;
  }
  function answered(c) {
    var a = (c && c.attributes) || {};
    return String(a['Size Scan'] || '') === 'Ignored' && !!a['Size Scan Reason'];
  }
  /* The costume's OWN name for the recommended size (e.g. "X-Large", not Mirrorsize's "Extra Large").
     Looked up once per costume from /products/<handle>.js; until it arrives the card uses the
     generic name, then repaints. */
  var labels = {};
  function recLabel(it, rec) {
    var k = it.handle + '|' + szKey(rec);
    if (Object.prototype.hasOwnProperty.call(labels, k)) return labels[k] || prettySize(rec);
    labels[k] = null;   // lookup in flight
    variantFor(it, rec).then(function (f) { labels[k] = f ? shortSize(f.label) : ''; paint(); })
      .catch(function () { labels[k] = ''; });
    return prettySize(rec);
  }
  function recFor(it) {
    var c = cachedScan(it.product_id);
    return c && c.state === 'recommended' && c.size ? c.size : null;
  }

  /* What the card for this line should say → {cls, html} or null for no card. */
  function cardFor(it, c) {
    var v = String((it.properties || {})._jk_size_scan || '').toLowerCase();
    var sz = lineSize(it), szS = shortSize(sz);
    var guaranteeOn = '<p><b>&#10003; Size Fit Guarantee activated</b></p>';
    function offCard(rec) {
      var name = recLabel(it, rec);
      return { cls: 'jk-sc--off', key: 'off:' + rec + ':' + name,
        html: '<p><b>Fit Guarantee voided</b> - recommended size is ' + esc(name) + '</p>' +
              '<p class="jk-sc__acts"><button type="button" class="jk-sc__go" data-jk-sc="swap" data-rec="' + esc(rec) + '">Swap to ' + esc(name) + '</button></p>' };
    }
    if (v === 'recommended') return { cls: 'jk-sc--ok', key: 'ok', html: guaranteeOn };
    if (v === 'ignored') {
      var r = recFor(it);
      if (r && szKey(r) !== szKey(sz)) return offCard(r);
      return { cls: 'jk-sc--off', key: 'off', html: '<p><b>Fit Guarantee voided</b> - not your recommended size</p>' };
    }
    if (v === 'nomatch' || v === 'mismatch') {
      return { cls: 'jk-sc--na', key: 'na', html: '<p>Size Fit Guarantee not available for this costume.</p>' };
    }
    if (v) return null;
    if (hasScan()) {
      var cs = cachedScan(it.product_id);
      if (cs && cs.state === 'recommended' && cs.size) {
        if (szKey(cs.size) === szKey(sz)) return { cls: 'jk-sc--ok', key: 'ok2', html: '<p><b>&#10003; Your recommended size</b></p>' };
        return offCard(cs.size);
      }
      if (cs && (cs.state === 'nomatch' || cs.state === 'mismatch')) {
        return { cls: 'jk-sc--na', key: 'na', html: '<p>Size Fit Guarantee not available for this costume.</p>' };
      }
      return null;   // unknown → the checkout size check asks Mirrorsize
    }
    if (answered(c)) {
      return { cls: 'jk-sc--na', key: 'skipped',
        html: '<p>Size Fit Guarantee not activated &middot; <button type="button" data-jk-sc="scan">Check my size</button></p>' };
    }
    var q = isOneSize(sz) ? 'Will this fit you?' : 'Is ' + esc(szS) + ' your size?';
    return { cls: 'jk-sc--ask', key: 'ask',
      html: '<p><b>' + q + '</b> A 2-min scan activates your Size Fit Guarantee.</p>' +
            '<p class="jk-sc__acts">' +
              '<button type="button" class="jk-sc__go" data-jk-sc="scan">Check my size</button>' +
              '<button type="button" data-jk-sc="know">I know my size</button>' +
            '</p>' };
  }

  function paint() {
    if (!cart) return;
    var items = cart.items || [];
    drawerLines().forEach(function (li, i) {
      var it = itemFor(li, items, i);
      var card = it && isCostume(it) ? cardFor(it, cart) : null;
      var el = li.querySelector('.jk-sc');
      if (!card) { if (el) el.parentNode.removeChild(el); return; }
      var k = it.key, err = errors[k];
      var want = card.cls + '|' + card.key + '|' + (busyLines[k] || '') + '|' + (err || '');
      if (el && el.getAttribute('data-jk-want') === want) return;    // already right — no DOM churn
      if (!el) {
        el = document.createElement('div');
        var host = li.querySelector('.horizontal-product__details > .flex.flex-col.gap-1') || li.querySelector('.horizontal-product__details') || li;
        if (host.classList && host.classList.contains('horizontal-product__details')) host.appendChild(el);
        else host.parentNode.insertBefore(el, host.nextSibling);
      }
      el.className = 'jk-sc ' + card.cls;
      el.setAttribute('data-jk-want', want);
      el.setAttribute('data-jk-key', k);
      el.innerHTML = card.html + (err ? '<p class="jk-sc__err">' + esc(err) + '</p>' : '');
      if (busyLines[k]) Array.prototype.forEach.call(el.querySelectorAll('button'), function (b) { b.disabled = true; });
    });
  }

  var waitSince = 0;
  function refresh(force) {
    if (!drawer) return;
    var lines = drawerLines();
    if (!lines.length) return;
    var s = lines.map(function (li) { return li.id + ':' + li.getAttribute('data-quantity'); }).join(',');
    if (!force && s === sig && cart) { paint(); return; }
    if (fetching) { refetch = true; return; }
    /* let jokers-cart.js finish a write first — but never wait more than 4s */
    if ((jk().removing || jk().writes) && (!waitSince || Date.now() - waitSince < 4000)) {
      if (!waitSince) waitSince = Date.now();
      schedule(400, force); return;
    }
    waitSince = 0;
    fetching = true;
    getCart().then(function (c) {
      cart = c; sig = s;
    }).catch(function () {}).then(function () {
      fetching = false;
      paint();
      if (refetch) { refetch = false; refresh(true); }
    });
  }
  /* Arm ONCE — never reset. The drawer mutates constantly (delivery widget, timers), and a
     resettable debounce was starved by that churn, so the cards never painted on the live page. */
  var forceNext = false;
  function schedule(ms, force) {
    if (force) forceNext = true;
    if (timer) return;
    timer = setTimeout(function () { timer = null; var f = forceNext; forceNext = false; refresh(f); }, ms || 250);
  }

  /* ---- actions ---- */
  function closeDrawer() {
    var d = document.getElementById('CartDrawer');
    try { if (d && typeof d.hide === 'function') { d.hide(); return; } } catch (e) {}
    var ov = d && d.querySelector('overlay-element, [aria-controls="CartDrawer"]');
    if (ov) ov.click();
  }
  function startScan(it) {
    var btn = document.getElementById('generateBtn');
    if (btn && !btn.disabled && !hasScan()) {
      closeDrawer();
      setTimeout(function () {
        var wrap = btn.closest('.main-wrapper-size-quicksize') || btn;
        try { wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        btn.click();
      }, 350);
      return;
    }
    try {
      sessionStorage.removeItem('jk_scan_return');
      var fit = /women|ladies/i.test((it && it.product_type) || '') ? 'women' : 'men';
      localStorage.setItem('jk_scan_page_fit', fit);
    } catch (e) {}
    location.href = '/pages/find-your-fit#jk-fyf-scan';
  }
  function knowMySize(k) {
    busyLines[k] = 'know'; delete errors[k]; paint();
    var attrs = {
      'Size Scan': 'Ignored',
      'Size Scan Reason': SKIP_REASON,
      'Size Scan Tried On': '',
      'Size Scan Problem': '',
      'Size Scan Details': '',
      'Size Scan Record': 'None on this device',
      'Size Scan Device': deviceInfo(),
      'Size Scan Check': '',
      'Size Scan Acknowledged': '',
      'Size Scan Skipped At': stampNow()
    };
    function attempt(n) {
      return whenIdle().then(function () { return post('/cart/update.js', { attributes: attrs }); })
        .catch(function (e) { if (n < 2) return new Promise(function (r) { setTimeout(r, 600); }).then(function () { return attempt(n + 1); }); throw e; });
    }
    attempt(0).then(function (c) {
      if (c && c.items) cart = c; else if (cart) cart.attributes = Object.assign({}, cart.attributes, attrs);
    }).catch(function () {
      errors[k] = 'Sorry, that didn’t save — please try again.';
    }).then(function () { delete busyLines[k]; paint(); });
  }
  function variantFor(it, rec) {
    return fetch('/products/' + encodeURIComponent(it.handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var idx = -1;
        (p.options || []).forEach(function (o, i) { var n = typeof o === 'string' ? o : (o && o.name); if (idx < 0 && /size/i.test(n || '')) idx = i; });
        if (idx < 0) idx = 0;
        var cur = (p.variants || []).filter(function (v) { return String(v.id) === String(it.id); })[0];
        return (p.variants || []).filter(function (v) {
          if (!v.options || szKey(v.options[idx]) !== szKey(rec)) return false;
          return !cur || v.options.every(function (o, i) { return i === idx || o === cur.options[i]; });
        }).map(function (v) { return { v: v, label: v.options[idx] }; })[0] || null;
      });
  }
  function swap(k, rec) {
    var it = (cart && cart.items || []).filter(function (x) { return x.key === k; })[0];
    if (!it) return;
    busyLines[k] = 'swap'; delete errors[k]; paint();
    variantFor(it, rec).then(function (f) {
      if (!f) throw new Error('unmade');
      if (!f.v.available) throw new Error('soldout:' + f.label);
      return lock(function () {
        return getCart().then(function (c) {
          var cur = (c.items || []).filter(function (x) { return x.key === k; })[0] ||
                    (c.items || []).filter(function (x) { return String(x.id) === String(it.id); })[0];
          if (!cur) throw new Error('gone');
          var props = Object.assign({}, cur.properties || {});
          props._jk_size_scan = 'recommended';
          props._jk_size_note = 'Swapped in cart ' + stampNow() + ' from ' + lineSize(cur) + ' to ' + f.label + ' (recommended size)';
          return post('/cart/add.js?csapp=shipcs', { items: [{ id: f.v.id, quantity: cur.quantity, properties: props }] })
            .then(function () { return post('/cart/change.js?csapp=shipcs', { id: cur.key, quantity: 0 }); });
        });
      });
    }).then(function () {
      delete busyLines[k];
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: {} }));
      schedule(300, true);
    }).catch(function (e) {
      delete busyLines[k];
      var m = String(e && e.message || '');
      errors[k] = m.indexOf('soldout:') === 0 ? shortSize(m.slice(8)) + ' is sold out in this costume.'
                : m === 'unmade' ? 'This costume doesn’t come in ' + recLabel(it, rec) + '.'
                : 'Sorry, we couldn’t swap the size — please change it on the product page.';
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: {} }));
      schedule(300, true);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-jk-sc]');
    if (!b || !drawer || !drawer.contains(b)) return;
    e.preventDefault();
    e.stopPropagation();
    var card = b.closest('.jk-sc'), k = card && card.getAttribute('data-jk-key');
    if (!k || busyLines[k]) return;
    var act = b.getAttribute('data-jk-sc');
    var it = (cart && cart.items || []).filter(function (x) { return x.key === k; })[0];
    if (act === 'scan') startScan(it);
    else if (act === 'know') knowMySize(k);
    else if (act === 'swap') swap(k, b.getAttribute('data-rec'));
  }, true);

  function bootDrawer() {
    drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    /* Our own card writes are ignored (only line-list changes matter), so this can't loop. */
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType === 1 && (t.classList.contains('jk-sc') || (t.closest && t.closest('.jk-sc')))) continue;
        var nodes = [].slice.call(muts[i].addedNodes).concat([].slice.call(muts[i].removedNodes));
        if (nodes.length && nodes.every(function (n) { return n.nodeType === 1 && n.classList && n.classList.contains('jk-sc'); })) continue;
        schedule(250);
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', function () { schedule(600, true); });
    document.addEventListener('cart:updated', function () { schedule(400, true); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(300, true); });
    /* a scan done in another tab / on the scan page, then back here */
    window.addEventListener('storage', function (e) { if (e.key && (e.key === 'ms_access_code2' || e.key.indexOf('jk_ms:') === 0)) schedule(200); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(200, true); });
    /* safety net: re-check every 2s (no network unless the cart lines changed; no DOM writes if
       the cards are already right) */
    setInterval(function () { refresh(false); }, 2000);
    schedule(50, true);
  }

  /* =====================================================================
     PRODUCT PAGE — reminder under Add to cart when the selected size isn't the
     recommended one (reads sizer-block's amber card; changes nothing in it)
     ===================================================================== */
  function bootPdp() {
    var rec = document.getElementById('jk-sz-recommended');
    if (!rec) return;
    var note = null;
    function submit() { return document.querySelector('.product-form__submit'); }
    function anchor(btn) {
      /* the row holding quantity + Add to cart (stop at the form) */
      var el = btn.parentElement, form = btn.closest('form');
      while (el && el !== form && el !== document.body) {
        if (el.querySelector('input[name="quantity"], quantity-selector, .quantity')) return el;
        el = el.parentElement;
      }
      return btn.parentElement;
    }
    function txt(sel) { var e = rec.querySelector(sel); return e ? e.textContent.trim() : ''; }
    function sync() {
      var off = rec.classList.contains('jk-sz--off') && rec.classList.contains('is-active');
      var btn = submit();
      if (!btn) return;
      if (!note) {
        note = document.createElement('p');
        note.className = 'jk-atc-note';
        note.hidden = true;
        note.innerHTML = '<span data-n></span><button type="button" data-jk-atc-switch></button>';
        note.querySelector('[data-jk-atc-switch]').addEventListener('click', function () {
          var sw = rec.querySelector('[data-jk-switch]');
          if (sw) sw.click();
        });
      }
      var a = anchor(btn);
      if (note.previousElementSibling !== a && a.parentNode) a.parentNode.insertBefore(note, a.nextSibling);
      if (!off) { if (!note.hidden) note.hidden = true; return; }
      var sel = txt('.jk-sz__card-title [data-jk-sel]'), r = txt('.jk-sz__card-links [data-jk-rec]') || txt('[data-jk-rec]');
      var n = (sel || 'This size') + ' isn’t covered by the Size Fit Guarantee ·';
      var s = r ? 'Switch to ' + r : '';
      var ns = note.querySelector('[data-n]'), sb = note.querySelector('[data-jk-atc-switch]');
      if (ns.textContent !== n) ns.textContent = n;
      if (sb.textContent !== s) sb.textContent = s;
      sb.hidden = !s;
      if (note.hidden) note.hidden = false;
    }
    var t = null;
    function later() { clearTimeout(t); t = setTimeout(sync, 60); }
    try {
      new MutationObserver(later).observe(rec, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true, characterData: true });
    } catch (e) {}
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker')) later(); }, true);
    later();
  }

  var booted = false;
  function boot() { if (booted) return; booted = true; bootDrawer(); bootPdp(); }
  /* After load (ShipZip has booted by then) — or 2.5s after the DOM is ready if 'load' is held up
     by a slow third-party script. */
  if (document.readyState === 'complete') boot();
  else {
    window.addEventListener('load', boot);
    var dcl = function () { setTimeout(boot, 2500); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dcl); else dcl();
  }
  window.__jkSizeCardVersion = '101026e';
})();
